module.exports = __webpack_public_path__ + "static/img/avatar_r_12.12016780.png";